import "./styles.scss"

const Overlay = ({ loading = false, label }) => {
  return (
    <div className={`overlay ${loading ? 'visible' : 'hidden'}`}>
      <div className="overlay-content">
        <div className="spinner" />
        {label && <span className="overlay-label">{label}</span>}
      </div>
    </div>
  );
};

export default Overlay